module.exports = __webpack_public_path__ + "static/media/Thai-LiveNow.972d435f.svg";